/**
 * Swym Wishlist Plus + Symmetry theme fixes
 *
 * 1. Symmetry's <filter-container> re-fetches the collection grid on ANY popstate,
 *    including Swym's hash-only "#swym-list" change when the wishlist drawer opens.
 *    We only let it through when the path or query string actually changed.
 *
 * 2. Symmetry re-renders the header icon group after cart changes, which drops the
 *    node Swym injected on page load. We cache that node and re-insert it as needed.
 *
 * Load via Theme settings > Advanced > Custom HTML:
 *   <script src="{{ 'swym-header-fix.js' | asset_url }}" defer></script>
 */
(function () {

  // ---------------------------------------------------------------------------
  // 1. Ignore hash-only URL changes in Symmetry's collection filter popstate
  // ---------------------------------------------------------------------------
  var lastUrl = location.pathname + location.search;

  // Keep lastUrl in sync with Symmetry's own pushState calls (filter/sort clicks)
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () {
      var r = orig.apply(this, arguments);
      lastUrl = location.pathname + location.search;
      return r;
    };
  });

  function patchFilterContainers() {
    document.querySelectorAll('filter-container').forEach(function (fc) {
      if (fc._swymPatched || !fc.boundAjaxPopState) return;
      fc._swymPatched = true;
      var origHandler = fc.boundAjaxPopState;
      window.removeEventListener('popstate', origHandler);
      fc.boundAjaxPopState = function (e) {
        var now = location.pathname + location.search;
        if (now === lastUrl) return; // hash-only change: ignore
        lastUrl = now;
        origHandler(e);
      };
      window.addEventListener('popstate', fc.boundAjaxPopState);
    });
  }

  if (window.customElements) {
    customElements.whenDefined('filter-container').then(function () {
      setTimeout(patchFilterContainers, 0);
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(patchFilterContainers, 0);
  });

  // ---------------------------------------------------------------------------
  // 2. Keep Swym's header icon alive across Symmetry's header re-renders
  // ---------------------------------------------------------------------------
  var saved = null;

  function grab() {
    var el = document.getElementById('swym-advanced-header-icon');
    if (el) saved = el;
  }

  function restore() {
    if (!saved || document.body.contains(saved)) return;
    var cart = document.querySelector('a.cart-link');
    if (cart) cart.parentNode.insertBefore(saved, cart);
  }

  // Cache the icon once Swym has injected it
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () { setTimeout(grab, 500); });

  // Fallback in case Swym injects later than the callback fires
  if (document.body) {
    new MutationObserver(function () {
      if (!saved) grab();
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Re-insert after any cart-related update
  ['on:cart:add', 'on:line-item:change', 'on:cart:after-merge', 'on:cart-drawer:after-open']
    .forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(restore, 50); });
    });
})();
